import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Label } from '@/components/ui';
import { cn } from '@/lib/utils';
import {
  SNIPPET_LANGUAGES,
  buildSnippet,
  type SnippetContext,
  type SnippetLanguage,
} from './snippets';

/**
 * Payment-Link Link-Tester — Snippet-Panel (Spec 501, Phase 6).
 *
 * Sprach-Auswahl (4 Devportal-Sprachen) + Gerüst-Ausgabe. Die vollstaendigen
 * Signier-Bodies kommen mit der Format-Definition; hier steht die Struktur mit dem
 * `<SALT>`-Platzhalter — nie der echte Salt (der `SnippetContext` traegt keinen).
 */
export function SnippetPanel({ ctx }: { ctx: SnippetContext }) {
  const { t } = useTranslation('payment-link');
  const [lang, setLang] = useState<SnippetLanguage>('typescript');

  return (
    <div className="space-y-2">
      <Label>{t('tester.snippets.title')}</Label>
      <div
        className="flex flex-wrap gap-1"
        role="group"
        aria-label={t('tester.snippets.language')}
      >
        {SNIPPET_LANGUAGES.map((l) => (
          <button
            key={l}
            type="button"
            onClick={() => setLang(l)}
            aria-pressed={l === lang}
            className={cn(
              'touch-manipulation rounded border px-2 py-0.5 text-xs coarse:min-h-10 coarse:px-3',
              l === lang ? 'bg-accent' : 'hover:bg-accent/50',
            )}
          >
            {l}
          </button>
        ))}
      </div>
      <pre
        className="overflow-x-auto rounded bg-muted p-2 font-mono text-xs"
        data-testid="snippet-output"
      >
        {buildSnippet(lang, ctx, {
          title: t('tester.snippets.comment.title'),
          testVector: t('tester.snippets.comment.testVector'),
          saltAsText: t('tester.snippets.comment.saltAsText'),
          byteSort: t('tester.snippets.comment.byteSort'),
        })}
      </pre>
    </div>
  );
}
